import Adresse from 'entity/Adresse'
import { Dvf } from 'interfaces/Parcelle'

export default class SellHistory {
  private _date: Date

  private _price: number

  private _surfaceHabitable: number

  private _nbPiece: number

  private _typeLocal: number

  private _adresse: Adresse

  constructor(history: Dvf) {
    this._date = new Date(history.date)
    this._price = history.prix
    this._surfaceHabitable = history.surfaceHabitable
    this._nbPiece = history.nombrePieces
    this._typeLocal = history.typeLocal
    this._adresse = new Adresse(history.adresseVoirie, history.adresseCommune)
  }

  get date(): Date {
    return this._date
  }

  get price(): number {
    return this._price
  }

  get surfaceHabitable(): number {
    return this._surfaceHabitable
  }

  get nbPiece(): number {
    return this._nbPiece
  }

  get typeLocal(): number {
    return this._typeLocal
  }

  get adresse(): Adresse {
    return this._adresse
  }
}
